import { Attachment, TaskStatus } from "../reducers/task/taskTypes";
export const countryOptions = [
  { option: "Afghanistan" },
  { option: "Albania" },
  { option: "Algeria" },
  { option: "Andorra" },
  { option: "Angola" },
  { option: "Antigua and Barbuda" },
  { option: "Argentina" },
  { option: "Armenia" },
  { option: "Australia" },
  { option: "Austria" },
  { option: "Azerbaijan" },
  { option: "Bahamas" },
  { option: "Bahrain" },
  { option: "Bangladesh" },
  { option: "Barbados" },
  { option: "Belarus" },
  { option: "Belgium" },
  { option: "Belize" },
  { option: "Benin" },
  { option: "Bhutan" },
  { option: "Bolivia" },
  { option: "Bosnia and Herzegovina" },
  { option: "Botswana" },
  { option: "Brazil" },
  { option: "Brunei" },
  { option: "Bulgaria" },
  { option: "Burkina Faso" },
  { option: "Burundi" },
  { option: "Côte d'Ivoire" },
  { option: "Cabo Verde" },
  { option: "Cambodia" },
  { option: "Cameroon" },
  { option: "Canada" },
  { option: "Central African Republic" },
  { option: "Chad" },
  { option: "Chile" },
  { option: "China" },
  { option: "Colombia" },
  { option: "Comoros" },
  { option: "Congo" },
  { option: "Costa Rica" },
  { option: "Croatia" },
  { option: "Cuba" },
  { option: "Cyprus" },
  { option: "Czechia" },
  { option: "Democratic Republic of the Congo" },
  { option: "Denmark" },
  { option: "Djibouti" },
  { option: "Dominica" },
  { option: "Dominican Republic" },
  { option: "Ecuador" },
  { option: "Egypt" },
  { option: "El Salvador" },
  { option: "Equatorial Guinea" },
  { option: "Eritrea" },
  { option: "Estonia" },
  { option: "Eswatini" },
  { option: "Ethiopia" },
  { option: "Fiji" },
  { option: "Finland" },
  { option: "France" },
  { option: "Gabon" },
  { option: "Gambia" },
  { option: "Georgia" },
  { option: "Germany" },
  { option: "Ghana" },
  { option: "Greece" },
  { option: "Grenada" },
  { option: "Guatemala" },
  { option: "Guinea" },
  { option: "Guinea-Bissau" },
  { option: "Guyana" },
  { option: "Haiti" },
  { option: "Holy See" },
  { option: "Honduras" },
  { option: "Hungary" },
  { option: "Iceland" },
  { option: "India" },
  { option: "Indonesia" },
  { option: "Iran" },
  { option: "Iraq" },
  { option: "Ireland" },
  { option: "Israel" },
  { option: "Italy" },
  { option: "Jamaica" },
  { option: "Japan" },
  { option: "Jordan" },
  { option: "Kazakhstan" },
  { option: "Kenya" },
  { option: "Kiribati" },
  { option: "Kuwait" },
  { option: "Kyrgyzstan" },
  { option: "Laos" },
  { option: "Latvia" },
  { option: "Lebanon" },
  { option: "Lesotho" },
  { option: "Liberia" },
  { option: "Libya" },
  { option: "Liechtenstein" },
  { option: "Lithuania" },
  { option: "Luxembourg" },
  { option: "Madagascar" },
  { option: "Malawi" },
  { option: "Malaysia" },
  { option: "Maldives" },
  { option: "Mali" },
  { option: "Malta" },
  { option: "Marshall Islands" },
  { option: "Mauritania" },
  { option: "Mauritius" },
  { option: "Mexico" },
  { option: "Micronesia" },
  { option: "Moldova" },
  { option: "Monaco" },
  { option: "Mongolia" },
  { option: "Montenegro" },
  { option: "Morocco" },
  { option: "Mozambique" },
  { option: "Myanmar" },
  { option: "Namibia" },
  { option: "Nauru" },
  { option: "Nepal" },
  { option: "Netherlands" },
  { option: "New Zealand" },
  { option: "Nicaragua" },
  { option: "Niger" },
  { option: "Nigeria" },
  { option: "North Korea" },
  { option: "North Macedonia" },
  { option: "Norway" },
  { option: "Oman" },
  { option: "Pakistan" },
  { option: "Palau" },
  { option: "Palestine State" },
  { option: "Panama" },
  { option: "Papua New Guinea" },
  { option: "Paraguay" },
  { option: "Peru" },
  { option: "Philippines" },
  { option: "Poland" },
  { option: "Portugal" },
  { option: "Qatar" },
  { option: "Romania" },
  { option: "Russia" },
  { option: "Rwanda" },
  { option: "Saint Kitts and Nevis" },
  { option: "Saint Lucia" },
  { option: "Saint Vincent and the Grenadines" },
  { option: "Samoa" },
  { option: "San Marino" },
  { option: "Sao Tome and Principe" },
  { option: "Saudi Arabia" },
  { option: "Senegal" },
  { option: "Serbia" },
  { option: "Seychelles" },
  { option: "Sierra Leone" },
  { option: "Singapore" },
  { option: "Slovakia" },
  { option: "Slovenia" },
  { option: "Solomon Islands" },
  { option: "Somalia" },
  { option: "South Africa" },
  { option: "South Korea" },
  { option: "South Sudan" },
  { option: "Spain" },
  { option: "Sri Lanka" },
  { option: "Sudan" },
  { option: "Suriname" },
  { option: "Sweden" },
  { option: "Switzerland" },
  { option: "Syria" },
  { option: "Tajikistan" },
  { option: "Tanzania" },
  { option: "Thailand" },
  { option: "Timor-Leste" },
  { option: "Togo" },
  { option: "Tonga" },
  { option: "Trinidad and Tobago" },
  { option: "Tunisia" },
  { option: "Turkey" },
  { option: "Turkmenistan" },
  { option: "Tuvalu" },
  { option: "Uganda" },
  { option: "Ukraine" },
  { option: "United Arab Emirates" },
  { option: "United Kingdom" },
  { option: "United States of America" },
  { option: "Uruguay" },
  { option: "Uzbekistan" },
  { option: "Vanuatu" },
  { option: "Venezuela" },
  { option: "Vietnam" },
  { option: "Yemen" },
  { option: "Zambia" },
];

export const qualificationOptions = [
  { option: "bachelor", label: "Bachelor's Degree" },
  { option: "master", label: "Master's Degree" },
  { option: "phd", label: "Ph.D." },
  { option: "other", label: "Other" },
];

export const subjectOptions = [
  { option: "math", label: "Mathematics" },
  { option: "science", label: "Science" },
  { option: "english", label: "English" },
  { option: "history", label: "History" },
  { option: "computer", label: "Computer Science" },
];

export const safeJsonParse = (
  value: any,
  defaultValue: any = []
) => {
  if (!value) return defaultValue;

  // If it's already an array or object, just return it as-is
  if (typeof value === "object") {
    return value;
  }

  // Otherwise, try to parse stringified JSON
  try {
    return JSON.parse(value);
  } catch (error) {
    return defaultValue;
  }
};


export const getStatusColor = (status: TaskStatus): string => {
  switch (status) {
    case "Submitted":
      return "bg-green-100 text-green-800";
    case "Pending":
      return "bg-yellow-100 text-yellow-800";
    case "Graded":
      return "bg-indigo-100 text-indigo-800";
    case "Late":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const formatDate = (date: string | Date): string => {
  return new Date(date).toLocaleDateString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatTime = (time: string): string => {
  return new Date(`2000-01-01T${time}`).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};


export const generateThumbnail = async (url: string): Promise<string> => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error generating thumbnail:", error);
    return "";
  }
};

const bgColors = [
  "bg-rose-100",
  "bg-pink-100",
  "bg-fuchsia-100",
  "bg-purple-100",
  "bg-violet-100",
  "bg-indigo-100",
  "bg-indigo-100",
  "bg-sky-100",
  "bg-cyan-100",
  "bg-teal-100",
  "bg-emerald-100",
  "bg-green-100",
  "bg-lime-100",
  "bg-amber-100",
  "bg-orange-100",
];

export const getRandomColor = () => {
  const randomIndex = Math.floor(Math.random() * bgColors.length);
  return bgColors[randomIndex];
};

const gradientPairs = [
  "from-fuchsia-600 to-purple-600",
  "from-violet-600 to-indigo-600",
  "from-indigo-600 to-sky-600",
  "from-cyan-600 to-teal-600",
  "from-emerald-600 to-green-600",
  "from-lime-600 to-yellow-600",
  "from-indigo-600 to-sky-800",
  "from-indigo-600 to-indigo-600"
];

export const getRandomGradient = () => {
  const randomIndex = Math.floor(Math.random() * gradientPairs.length);
  return gradientPairs[randomIndex];
};

export const formatLongDate = (dateString: string | null | undefined) => {
    if (!dateString) return 'N/A';
    
    const date = new Date(dateString);
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      console.warn(`Invalid date string: ${dateString}`);
      return 'Invalid Date';
    }
    
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };

  export const getWeekBounds = () => {
  const now = new Date();
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  start.setDate(now.getDate() - now.getDay()); // Sunday
  const end = new Date(start);
  end.setDate(start.getDate() + 7); // Next Sunday
  return { start, end };
};